import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import useMediaQuery from "../../hooks/useMediaQuery";
import { UserContext } from "../../shared/context/UserContext";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import PersonalDetails from "../basic-details/PersonalDetails";
import ProfessionalDetails from "../professional-details/ProfessionalDetails";
import { GetCustomerDetailsContext, validateInputExistenece } from "../../App";

const getInternalStage = (stage, stage_status) => {
  if (stage === "BASIC_INFO" && stage_status === "INIT") {
    return "BASIC_INFO_INIT";
  } else if (stage === "CCC" && stage_status === "INIT") {
    return "CCC_INIT";
  } else {
    return "BASIC_INFO_INIT";
  }
};

const Details = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  const { user, setUser } = useContext(UserContext);
  const [detailsType, setDetailsType] = useState(0);
  const [modal, setModal] = useState("");
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  // );

  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [showShimmer, setShowShimmer] = useState(true);
  useEffect(() => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      setShowShimmer(false);
      // console.log("Details customerDetails: ", customerDetails);

      if (
        customerDetails.stage === "PROFESSIONAL_START" ||
        customerDetails.stage === "PROFESSIONAL_VERIFY" ||
        customerDetails.stage === "SELF_EMPLOYED_LEAD_CAPTURED"
      ) {
        setDetailsType(1);
      }

      // TODO: setDetailsType to 0 or 1 based on customerDetails["stage"]

      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
        state: {
          customerDetails: customerDetails,
        },
      });
      // history.replace({
      //   pathname: `${route}`,
      //   search: location.search,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    } else {
      // console.log("Details Ouch customerDetails ");
    }
  }, [customerDetails]);

  return (
    <>
      <ProgressBar showProgress={true} currentStep={1} showText={false} />
      <AfterLoginLayoutWrapper>
        <div className="details-btn-row">
          {showShimmer ? (
            <>
              <ShimmerPlaceholder
                visible={showShimmer}
                height="4em"
                width="11em"
              />
              <ShimmerPlaceholder
                visible={showShimmer}
                height="4em"
                width="11em"
              />
            </>
          ) : (
            <>
              <div
                style={{ display: showShimmer ? "none" : "" }}
                className={
                  detailsType === 0 ? "details-btn colored" : "details-btn"
                }
                onClick={() => {
                  // setDetailsType(0);
                }}
              >
                Personal
              </div>

              <div
                style={{ display: showShimmer ? "none" : "" }}
                className={
                  detailsType === 1 ? "details-btn colored" : "details-btn"
                }
                onClick={() => {
                  // setDetailsType(1);
                }}
              >
                Professional
              </div>
            </>
          )}
        </div>
        {detailsType === 0 ? (
          <PersonalDetails
            changeDetailsType={setDetailsType}
            customerDetails={customerDetails}
          />
        ) : (
          <ProfessionalDetails customerDetails={customerDetails} />
        )}
      </AfterLoginLayoutWrapper>
    </>
  );
};

export default Details;
